import PbAjax from 'up-pbajax';
import PublicPb from '../publicpb';

/**
 * pb请求数据
 * @param {Object} config pbajax 配置
 * @param {Object} params 参数
 * @param {Object} pbObj 解析加密参数的pd对象
 */
function PbAjaxBase(config, params, pbObj) {
    //  编码请求参数
    let data = new pbObj.Request(params);
    let pbajax = new PbAjax();
    // console.log(`%c请求参数 ${config.api}`, 'color:blue', data);
    return new Promise((resolve, reject) => {
        pbajax.do(
            //  合并默认的配置和用户自定义的配置
            $.extend(true, {
                header: {
                    //  可以将大多数请求都会用到的header放在这里
                }
            }, config),
            data,
            resp => {
                // 解析外壳
                let dataWrapper = PublicPb.Result.decode(resp);
                // console.log(`%c返回的数据 ${config.api}`, 'color:green', dataWrapper);
                if (dataWrapper.code === 1) {
                    // 解析真实数据
                    if (dataWrapper.data.value) {
                        const data = pbObj.Response.decode(dataWrapper.data.value);
                        // console.log(`%c解析后的数据 ${config.api}`, 'color:red', data);
                        return resolve(data);
                    }
                    return resolve(null);
                }
                //  将code给扔出去
                reject(dataWrapper.code);
            },
            () => {
                reject('请求超时');
            },
            () => {
                reject('请求出错了');
            }
        );
    });
}

export default PbAjaxBase;



// WEBPACK FOOTER //
// ./js/services/pbAjaxbase.js